<div class="page-layout blank fullwidth p-12" fusePerfectScrollbar>
    <div class="mat-elevation-z8 mt-8 p-8 variant">

        <!-- Tabs -->
        <div class="vehicle-detail-header">
            <button type="button" class="back-button" (click)="goToYear()" aria-label="Back to year">
                <svg xmlns="http://www.w3.org/2000/svg" class="back-button__icon" viewBox="0 0 24 24">
                    <path d="M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z" />
                </svg>
            </button>
            <div class="vehicle-detail-label vehicle-detail-label--clickable" (click)="goToMake()">
                <div class="vehicle-detail-label__inner">{{ selectedMake }}
                    <hr class="vehicle-detail-label__hr">
                </div>
            </div>
            <div class="vehicle-detail-label vehicle-detail-label--clickable" (click)="goToModel()">
                <div class="vehicle-detail-label__inner">{{ selectedModel }}
                    <hr class="vehicle-detail-label__hr">
                </div>
            </div>
            <div class="vehicle-detail-label vehicle-detail-label--clickable" (click)="goToYear()">
                <div class="vehicle-detail-label__inner">{{ selectedYear }}
                    <hr class="vehicle-detail-label__hr">
                </div>
            </div>
            <div class="vehicle-detail-label vehicle-detail-label--active">
                <div class="vehicle-detail-label__inner">Variant
                    <hr class="vehicle-detail-label__hr vehicle-detail-label__hr--active">
                </div>
            </div>
        </div>
        <!-- End Tabs -->

        <h2 class="variant-title">What's your car's variant?</h2>

        <form class="search-variant-form">
            <div class="search-bar-wrap">
                <input type="text" class="search-bar" placeholder="Search for variant" [(ngModel)]="searchText" name="searchText" autocomplete="off" (keyup)="searchFilterType()">
                <mat-icon *ngIf="openSearch" class="search-bar-icon">search</mat-icon>
                <mat-icon *ngIf="clearSearch" class="search-bar-icon search-bar-icon--clear" (click)="clearSearchFilter()">close</mat-icon>
            </div>
        </form>

        <div class="variant-list-sec">
            <mat-tab-group mat-align-tabs="center" class="variant-tabs">
                <mat-tab label="Petrol" *ngIf="variantListPetrol.length > 0">
                    <div class="variant-list">
                        <button mat-raised-button type="button" class="variant_name" *ngFor="let variant of variantListPetrol | filter: searchText" (click)="selectVariant(variant.variantKey, variant.title, variant.fuelType)">{{ variant.title }}</button>
                    </div>
                </mat-tab>
                <mat-tab label="Diesel" *ngIf="variantListDiesel.length > 0">
                    <div class="variant-list">
                        <button mat-raised-button type="button" class="variant_name" *ngFor="let variant of variantListDiesel | filter: searchText" (click)="selectVariant(variant.variantKey, variant.title, variant.fuelType)">{{ variant.title }}</button>
                    </div>
                </mat-tab>
                <mat-tab label="CNG" *ngIf="variantListCNG.length > 0">
                    <div class="variant-list">
                        <button mat-raised-button type="button" class="variant_name" *ngFor="let variant of variantListCNG | filter: searchText" (click)="selectVariant(variant.variantKey, variant.title, variant.fuelType)">{{ variant.title }}</button>
                    </div>
                </mat-tab>
                <mat-tab label="Electric" *ngIf="variantListElectric.length > 0">
                    <div class="variant-list">
                        <button mat-raised-button type="button" class="variant_name" *ngFor="let variant of variantListElectric | filter: searchText" (click)="selectVariant(variant.variantKey, variant.title, variant.fuelType)">{{ variant.title }}</button>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
<div *ngIf="loading">
    <div #dynamicContainers></div>
</div>
